import React, { Component } from 'react';
import HeaderWrapper from './ui/header/HeaderWrapper';
import Logo from './ui/header/Logo';

class Header extends Component {
    render() {
        return (
            <HeaderWrapper>
                <Logo src={require(`../assets/images/${this.props.logo}`)} alt="Logo" />
            </HeaderWrapper>
        );
    }
}

export default Header;